import React, { useState } from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Section } from '../components/ui/Section';
import { Gallery } from '../components/ui/Gallery';
import { ContactCTA } from '../components/sections/ContactCTA';
import { galleryImages, services } from '../data/mock';
import { cn } from '../lib/utils';

export const GalleryPage = () => {
  const [activeCategory, setActiveCategory] = useState<string>('all');

  const categories = [
    { id: 'all', title: 'Sve' },
    ...services.map(s => ({ id: s.id, title: s.title }))
  ];

  const filteredImages = activeCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* Hero Section */}
      <div className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden bg-primary-dark">
        <div className="absolute inset-0 bg-black/50 z-0" />
        <div className="container mx-auto px-4 relative z-10 text-white text-center pt-20">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-fade-in-up">
            Galerija Radova
          </h1>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto leading-relaxed animate-fade-in-up delay-100">
            Pogledajte naše realizovane projekte i uverite se u kvalitet naše izrade.
          </p>
        </div>
      </div>

      <main className="flex-grow">
        <Section>
          <div className="container mx-auto">
            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={cn(
                    "px-6 py-2 rounded-full text-sm font-medium transition-all duration-300",
                    activeCategory === cat.id
                      ? "bg-primary text-white shadow-lg scale-105"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  )}
                >
                  {cat.title}
                </button>
              ))}
            </div>

            <Gallery images={filteredImages} />
          </div>
        </Section>

        <ContactCTA />
      </main>

      <Footer />
    </div>
  );
};
